const Medicine = () => {
  return <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <div className="mx-auto h-1.5 w-20 rounded-full bg-gradient-to-r from-[#F28600] to-[#ffb347]" />
                    <p className="mt-6 font-mulish text-sm font-semibold uppercase tracking-[0.3em] text-amber-800">
                        Weisheit aus Ernährung und Pflanzen
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-light leading-tight tracking-tight text-[#1f4d3c] sm:text-4xl lg:text-5xl">
                        Ayurveda-Medizin: Die Natur führt Körper und Geist in Harmonie
                    </h2>
                    <div className="mt-8 space-y-6 font-mulish text-base leading-8 text-gray-700 sm:text-lg">
                        <p>
                            In der Ayurveda-Welt gilt alles als heilend, was die vorliegenden Symptome lindert, ohne neue Beschwerden zu erzeugen. So betrachtet die Tradition die gesamte Umgebung, die Ernährung und das Verhalten als Teil der Heilung.
                        </p>
                        <p>
                            Besonders wichtig ist uns dabei die richtige tägliche Ernährung mit den sechs Geschmacksrichtungen (Rasa), damit die Lebensenergie im Körper – die Doshas – wieder in ihr natürliches Gleichgewicht kommen. Wenn Medikamente erforderlich sind, verwenden wir ausschließlich hochwertige, rein pflanzliche Kräuterprodukte von vertrauenswürdigen Herstellern, die strengen Prüfungen unterzogen wurden.
                        </p>
                    </div>
                    <div className="mx-auto mt-8 h-px w-32 bg-amber-200" />
                </div>
            </div>
        </section>;
};
export default Medicine;
